module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/js/core/fonts/MaterialIcons-Regular.woff
// module id = 22
// module chunks = 0